@if (isLoadingSpinnerVisible()) {
    <span [attr.data-qa]="qaTag() ? qaTag() : 'icon'" [innerHTML]="loadingSpinnerHtml() || null" [style]="style()" class="icon"></span>
} @else if (resolvedIconUrl()) {
    <img (error)="onImageLoadFinished()" (load)="onImageLoadFinished()" [attr.data-qa]="qaTag() ? qaTag() : 'icon'" [src]="resolvedIconUrl()!" [style]="style()" alt="" class="icon"/>
} @else {
    <span [attr.data-qa]="qaTag() ? qaTag() : 'icon'" [innerHTML]="svgHtml() || fallbackIconHtml() || null" [style]="style()" class="icon"></span>
}
